










































































































































































































































































































































































































































































	import { Watch, Component, tlStore } from "../../../Infrastructure/CorBase/CoreBase";
	import TaskDetailBase from "./TaskDetailBase";
	
	@Component
	export default class TaskDetail extends TaskDetailBase {

		//potřeba refresh při změně jazyka, když je to modal oknech

         //@ts-ignore
		@Watch('$i18n.locale')
		changeFieldsAfterChangeLanguage(value: boolean, oldValue: boolean) {
            this.changeFieldsAfterChangeLanguageBase(value, oldValue);
        }


        allowCancelInBlock(item: any) {           
            var isNewLastBlock = item.isNewBlock && this.formDataContentHead.length == 1;
            return item.isEditContentDetail && !isNewLastBlock;
        }

        goBackNotChangeAll() {
            this.goBackNotChangeAllBase();
        }

        prepareId(index: any) {
            var result = index + "blockEdit";
            return result;
        }

        isNotEditable() {
          return this.formData.isNotAllowEdit;
        }

		getEditTooltip() {
			return this.isNotEditable()
				? this.$t('taskDetail.editFormPreparing')
				: this.$t('taskDetail.editForm');
		}
   

        showBlockDelete(index: number, item: any) {
            return this.formDataContentHead.length > 1 && item.isNewBlock == false;
            //PUVODNI
         //   return this.formDataContentHead.filter(c => c.isNewBlock == false).length > 1;
        }

        anyChange(id: any) {
            this.anyChangeBase(id);
        }

        newBlock() {
            this.newBlockBase();
        }

        goToDetailReceiver(id: number) {
            this.$router.push({ name: 'ReceiverDetail', params: { id: id.toString() }, query: { id: id.toString() } });
		}

		goToDetailContent(id: number) {			
            this.$router.push({ name: 'ContentDetail', params: { id: id.toString() }, query: { id: id.toString() } });
        }

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}

		created() {
			//super.created();
			super.initializeRights('CON_Task_Create', 'CON_Task_Delete', 'CON_Task_Read', 'CON_Task_Update');
			super.setMainDescription('taskDetail.new', 'taskDetail.detail');
             super.setTimer(tlStore.state.pageTimer);
            this.createdBase();       
            this.mainDataChanged = false;
		}

        idTable: any;
        showDeleteBlockModal(more: any, idTable: any) {
            this.idTable = idTable;
            this.showAlertModalById("alertModalIdToDeleteBlock");
        }

        controlBeforeSave(update: boolean = false) {


            var sum = 0;    
            this.formDataContentHead.forEach(c => sum += c.contents == null? 0 :c.contents.length       );

            const hasWeekWithoutDays =  this.formDataContentHead.some(item => {
              const { week } = item;
              return week && Object.values(week).every(day => !day.selected);
            });

            if (sum == 0){
                this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSaveInfo').toString(), this.$t('taskDetail.errorSaveContent').toString());
            }
            else if (hasWeekWithoutDays){
                 this.showAlertModalWithTitleAndContent(this.$t('taskDetail.errorSaveInfo').toString(), this.$t('taskDetail.errorSaveContentDay').toString());
            }
            else {
                if (update) {
                    this.save();
                }
                this.saveAll();
            }
        }

        deleteBlock() {         
            this.deleteBlockBase(this.idTable.id);
        }

        changeTags(items: any): void {
            this.changeTagsBase(items);
        }

        goBackDetailTag(item: any): void {
            this.goBackDetailTagBase(item);
        }

		getPreviewId(id: number | null | undefined): string {
			return `image_detail_receiver_${id}`;
		}



        addContentDetail(more: any, idTable: any) {
			this.addContentDetailBase(idTable.id);
		}

		moveUp(idOrder: any, idTable: any, isInfoText: boolean) {
            this.moveUpBase(idOrder, idTable, isInfoText);
		}

        moveDown(idOrder: any, idTable: any, isInfoText: boolean) {
            this.moveDownBase(idOrder, idTable, isInfoText);
        }

        changeCheckboxHead(key: any, idTable: any) {
            this.changeCheckboxHeadBase( key, idTable);
        }

        changeCheckboxListHead(dayKey: any, order: any, key: any, idTable: any) {
            this.changeCheckboxListHeadBase(dayKey, order, key, idTable);
        }

        changeCheckbox(id: any, order: any, key: any, idTable: any ) {
            this.changeCheckboxBase(id, order, key, idTable);
		}

		changeCheckboxList(dayKey: any, order: any, key: any) {
			this.changeCheckboxListBase(dayKey, order, key);
		}

		changeInput(order: number, key: string, value: any) {
			this.changeInputBase(order, key, value);
		}

		startSettingMenu() {
			this.startSettingMenuBase();
		}

		deleteContentDetail(item: any, idTable: any) {
			this.deleteContentDetailBase(item, idTable);
		}

        saveSubMenuSetting(id: any, isInfoText: boolean) {
            this.saveSubMenuSettingBase(id, isInfoText);
		}

		goBackSubMenuSetting(id: any) {
			this.goBackSubMenuSettingBase(id);
		}

        saveContentDetail(id: any): void {
            this.saveContentBlockDetailBase(id,false);
			//this.saveContentDetailBase();
		}

        showAllSaveButton(): boolean {
            this.mainDataChangedSub = !this.formIsInEditMode && (this.isEditContentDetail || this.isEditReceiverDetail);
			return !this.formIsInEditMode && (this.isEditContentDetail || this.isEditReceiverDetail);
		}

        buttonVariantDelegate(): string {
            if (this.formData.isPriorityTask) {
                return "";
            }
            else if (this.formData.isInIdleTask) {
                return "green";
            }
            else {
                return "green"
            }
        }

        buttonIconDelegate(): string {
            if (this.formData.isPriorityTask || this.formData.isInIdleTask) {
                return "buttonIconOdeslat";
            }
            else {
                return "buttonIconSpustit";
            }
        }
        buttonNameDelegate(): string {
            if (this.formData.isPriorityTask || this.formData.isInIdleTask) {
                return this.$t('taskDetail.buttonSend').toString();
            }
            else {
                return this.$t('taskDetail.buttonRun').toString();
            }
        }

        disableSaveButton() {
            return this.validate() || (this.disabledSaveButton && !this.isEditContentDetail && !this.isEditReceiverDetail);
        }

        buttonNameDelegateTooltip(): string {
            if (this.isEditContentDetail || this.isEditReceiverDetail) {
                //return this.$t('taskDetail.buttonSaveDelegateTooltip').toString();
                if (this.formData.isPriorityTask || this.formData.isInIdleTask) {
                    return this.$t('taskDetail.buttonSaveSendTooltip').toString();
                }
                else {
                    return this.$t('taskDetail.buttonSaveRunTooltip').toString();
                }
            }
            else {
                //return this.$t('taskDetail.buttonDelegateTooltip').toString();
                if (this.formData.isPriorityTask || this.formData.isInIdleTask) {
                    return this.$t('taskDetail.buttonSendTooltip').toString();
                }
                else {
                    return this.$t('taskDetail.buttonRunTooltip').toString();
                }
            }
        }
        //prioritni
        buttonNamePlayTooltip(): string {
            var res = "";
            if (this.isEditContentDetail || this.isEditReceiverDetail) {
                res =  this.$t('taskDetail.buttonSaveDelegateTooltip').toString();
            }
            else {
                res = this.$t('taskDetail.buttonDelegatePriorityTooltip').toString();
            }
           // res = res + " " + this.$t('taskDetail.buttonDelegAndPlayTooltip').toString()
            return res;
        }

		saveAll(): void {
			if (this.isEditContentDetail) {
           //     this.saveContentDetailBase();
                this.saveContentBlockDetailBase(0,true);
			}
            if (this.isEditReceiverDetail) {
				this.saveReceiversDetail(false);
			}
		}

		addReceiverDetail(): void {
			this.addReceiverDetailBase()
		}

		deleteReceiverDetail(item: any) {
			this.deleteReceiverDetailBase(item);
		}

		selectedReceiverItems(items: any): void {
			this.selectedReceiverItemsBase(items);
		}

        selectedContentItems(items: any): void {
			this.selectedContentItemsBase(items);
		}

		mounted() {         
            this.timerHandle = setInterval(() => {
                this.timerRefresh();
            }, this.timerSecondRefresh);
            super.mounted();
        };
        
		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		isCorrectTaskType(value: any) {
			this.isCorrectTaskTypeBase(value);
		}

		isActiveTab(tabName: string): boolean {
			return this.isActiveTabBase(tabName);
		}


        addBlock(idTable: any, item: any, isInfoText: boolean) {
            this.addBlockBase(idTable.id, item, isInfoText);
        }

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && ((this.formIsInEditMode && this.dataWasChanged()) || this.mainDataChangedSub )) {
                event.preventDefault(); event.returnValue = "";
            }
        }
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            clearInterval(this.timerHandle);
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

    

	}
